import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React, { useMemo } from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
      "&.custom-tooltip": {
        width: '150px',
        padding: '5px',
        backgroundColor: '#5577cc',
        borderRadius: '4px',
      },
    },
  }));

export default (props) => {
    const classes = useStyles(props);
  const data = useMemo(
    () => props.api.getDisplayedRowAtIndex(props.rowIndex).data,
    []
  );

  return (
    <div className={clsx(classes.root, "custom-tooltip")} style={{ backgroundColor: props.color || '#999' }}
    >
      <p>Cumulative of STD + SPL 1 + PDR<span>{data?.lpWg1}</span></p>
      <p>{data?.stdDiscWg1} + {data?.lpWg1} + {0}</p>
    </div>
  );
};
